import React from 'react';
import './InsertTeeTimeButton.css';

function InsertTeeTimeButton({ position, onInsert, className = '' }) {
  const handleClick = () => {
    onInsert(position);
  };

  return (
    <button 
      className={`insert-tee-time-btn ${className}`}
      onClick={handleClick}
      title="Insert tee time here"
    >
      <span className="plus-icon">+</span>
    </button>
  );
}

export default InsertTeeTimeButton;